import * as React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { URL_PATHS } from "../../routes";

interface LoginRouteProps extends RouteProps {
    shouldRegister: boolean;
    children: JSX.Element;
}

const LoginRoute = (props: LoginRouteProps) => {
    const { children, shouldRegister, ...rest } = props;
    return (
        <Route
            {...rest}
            render={({ location }) =>
                shouldRegister ? (
                    <Redirect
                        to={{
                            pathname: URL_PATHS.registerPaid(),
                            state: { from: location }
                        }}
                    />
                ) : (
                    children
                )
            }
        />
    );
};

export default LoginRoute;
